import type { RouteLocationRaw } from 'vue-router';

export const useAuthStore = defineStore('plugin:auth', () =>
{
    const loaded = ref<boolean>(false);
    const authenticated = ref<boolean>(false);
    const identity = ref<AuthModel>(null);
    const rememberMe = ref<boolean>(false);
    const token = useLocalStorage('token', ref<string>(null));
    const impersonated = ref<number>(null);

    function setLoaded(value: boolean): void
    {
        loaded.value = value;
    }

    function setAuthenticated(value: boolean): void
    {
        authenticated.value = value;
    }

    function setIdentity(model: AuthModel): void
    {
        identity.value = model;
    }

    function clearIdentity(): void
    {
        identity.value = null;
    }

    function setRememberMe(enabled: boolean): void
    {
        rememberMe.value = enabled;
    }

    function setToken(value: string): void
    {
        token.value = value;
    }

    function impersonate(id: number): void
    {
        impersonated.value = id;
    }

    function unimpersonate(): void
    {
        impersonated.value = null;
    }

    return {
        loaded, authenticated, identity, rememberMe, token, impersonated,
        setLoaded, setAuthenticated, setIdentity, clearIdentity,
        setRememberMe, setToken, impersonate, unimpersonate
    };
});

export interface AuthRedirect
{
    homePage: RouteLocationRaw;
    loginPage: RouteLocationRaw;
    forbidden: RouteLocationRaw;
    notFound: RouteLocationRaw;
    changePassword: RouteLocationRaw;
}

export class AuthOptions
{
    public routes: AuthRedirect;
    public defaultPolicy: (token: Record<string, string>) => boolean = (token: Record<string, string>) => true;
    public windows: boolean;
    public azure: boolean;
}

export function adminAccessPolicy(token: Record<string, string>)
{
    const claimName = 'https://ideo.pl/identity/claims/permission';
    const claimValue = 'AdminAccess';

    return claimName in token && ([].concat(token[claimName])).includes(claimValue);
}

export function useAuthOptions(): AuthOptions
{
    return {
        routes: {
            homePage: { path: '/' },
            loginPage: { path: '/auth/login' },
            forbidden: { path: '/error/403' },
            notFound: { path: '/error/404' },
            changePassword: { name: 'core-account-password' }
        },
        defaultPolicy: adminAccessPolicy,
        windows: false,
        azure: false
    };
}
